import React from "react";
import { LoadingButton } from "@mui/lab";
import { darken } from "@mui/system";
import { useTheme } from "@mui/material/styles";

export default function CustomButton({ children, color = "#7CA7AD", loading, disabled, startIcon, endIcon, hover = true, ...props }) {
  const theme = useTheme();
  
  return (
    <LoadingButton
      {...props}
      loading={loading}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        color: "#FFFFFF",
        backgroundColor: color,
        "&:hover": {
          backgroundColor: hover ? darken(color, 0.15) : color,
          boxShadow: "none",
        },
        "&.Mui-disabled": {
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.disabledBackground,
        },
        boxShadow: "none",
        lineHeight: 'normal',
        textTransform: 'capitalize',
        padding: '10px 20px',
        ...props.sx,
      }}
      size="small"
    >
      {children}
    </LoadingButton>
  );
}